import React from 'react';

import './index.scss';

const RenovationStatus = ({ dataPolicy }) => {
  return (
    <div className="status-renovation">
      <span
        className={`status-renovation__icon ${
          dataPolicy.subscribedRenewal
            ? 'status-renovation__icon--active'
            : 'status-renovation__icon--inactive'
        }`}
      />
      <span>{dataPolicy.subscribedRenewal ? 'Activa' : 'Inactiva'}</span>
    </div>
  );
};

export default RenovationStatus;
